import React from 'react';
import { PixelRatio, StyleSheet, View } from 'react-native';
import { connect } from 'react-redux';
import {
  changeDosage,
  changeDosageUnits,
  changeMedicationType,
  checkMedication,
  checkNoMedications,
} from '../actions';
import ListSectionItem from '../../../design/components/ListSectionItem';
import {
  FloatingInput,
  Text,
  TouchableNative,
} from '../../../design/components';
import { designConstants } from '../../../design/styles';
import medsConstants from '../../Meds/constants';
import { getSeverityColor } from '../../../shared/utilities/colorutils';
import medsStrings from '../../Meds/strings';
import strings from '../strings';
import fields_names_strings from '../../Fields/fields_names_strings';
import { clearTemporaryMedicationInfo } from '../../Meds/actions';
import getConfig from '../../../shared/utilities/getConfig';
import Button from '../../../design/components/Button';
import sharedStrings from '../../../shared/strings';
import { toSentenceCase } from '../../../shared/utilities/stringsutils';
import { getMedicationNameAndBrand } from '../utils';
import { withTheme } from '../../../design/styles/useThemeContext';
import { isNothingNamedField } from '../../Fields/constants';

class MedicationListSectionContent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      meds: props.meds
        .filter(
          (f) =>
            (!!f && f.isMedication && f.show && f.medication) ||
            isNothingNamedField(f?.name),
        )
        .sort((a, b) => {
          if (isNothingNamedField(a.name)) {
            return -1;
          }
          if (isNothingNamedField(b.name)) {
            return 1;
          }

          return a.position !== b.position
            ? b.position - a.position
            : a.show !== b.show
              ? a.show
                ? -1
                : 1
              : (
                  (a.systemDefault && fields_names_strings[a.name]) ||
                  a.name
                ).localeCompare(
                  (b.systemDefault && fields_names_strings[b.name]) || b.name,
                );
        }),
      hiddenFieldsCount: this.getHiddenFieldsCount(props),
      no_medications: props.no_medications,
    };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.meds !== this.props.meds) {
      let meds = props.meds
        .filter(
          (f) =>
            (!!f && f.isMedication && f.show && f.medication) ||
            isNothingNamedField(f?.name),
        )
        .sort((a, b) => {
          if (isNothingNamedField(a.name)) {
            return -1;
          }
          if (isNothingNamedField(b.name)) {
            return 1;
          }
          return a.position !== b.position
            ? b.position - a.position
            : a.show !== b.show
              ? a.show
                ? -1
                : 1
              : (
                  (a.systemDefault && fields_names_strings[a.name]) ||
                  a.name
                ).localeCompare(
                  (b.systemDefault && fields_names_strings[b.name]) || b.name,
                );
        });
      this.setState({
        ...this.state,
        meds,
        hiddenFieldsCount: this.getHiddenFieldsCount(props),
      });
    }
  }

  onMedicationChange = (med) => {
    const isNothingChecked = this.state.no_medications;

    if (isNothingChecked) {
      this.props.dispatch(checkNoMedications(false));
      this.setState({ ...this.state, no_medications: false });
    }

    this.props.dispatch(checkMedication(med));
  };

  onTypePress = (med, type) => {
    this.props.dispatch(changeMedicationType(med, type));
  };

  onDosageInput = (med) => {
    return (dosage) => {
      this.props.dispatch(changeDosage(med, dosage, false));
    };
  };

  onDosageSelected = (med, dosage) => {
    return () => {
      //            this.setState({})
      this.props.dispatch(changeDosage(med, dosage, false));
    };
  };
  // onAddMedicationTextChange = (text) => {
  //     this.setState({text});
  //     this.props.dispatch(searchMedication(text));
  // }

  getHiddenFieldsCount(nextProps) {
    let fields = nextProps.meds.filter((field) => !!field && !!field.name);
    fields = fields.filter(
      (field) =>
        field &&
        !field.deleted &&
        field.medication &&
        field.isMedication &&
        !field.show,
    );
    return fields.length;
  }

  changeDosageUnits = (row, old_nid, units) => {
    let med = row.medication.find((med) => med.units === units);
    if (med.nid) {
      this.props.dispatch(changeDosageUnits(old_nid, med.nid));
    }
  };

  checkNothingNamed = () => {
    const { no_medications } = this.state;
    const { dispatch, current } = this.props;
    const newNoMedicationsValue = !no_medications;

    this.setState({ ...this.state, no_medications: newNoMedicationsValue });
    dispatch(checkNoMedications(newNoMedicationsValue));

    if (no_medications) {
      const checkedMeds = Object.keys(current);
      checkedMeds.forEach((nid) => {
        dispatch(checkMedication({ nid }));
      });
    }
  };

  renderRow = (row) => {
    let current = this.props.current;

    const { colors } = this.props.theme;

    const isNothingNamed = isNothingNamedField(row?.name);
    const isNothingChecked = this.state.no_medications;

    if (isNothingNamed) {
      const { icon, name } = row;

      return (
        <ListSectionItem
          key={'med' + name}
          style={{ marginHorizontal: designConstants.paddings.edgePadding }}
          checkbox
          onPress={() => this.checkNothingNamed()}
          checked={isNothingChecked}
          label={name}
          secondaryLabel={
            sharedStrings.list_section_content_nothing_item_subtitle
          }
          mmpicon={icon}
        />
      );
    }

    let medication = row.medication[0];
    if (row.medication.length > 0) {
      row.medication.forEach((med) => {
        if (this.props.current[med.nid]) {
          medication = med;
        }
      });
    }

    let isDev =
      !designConstants.isWeb &&
      (getConfig('MMP_APPLE_PACKAGE_NAME').includes('.dev') ||
        getConfig('MMP_APPLE_PACKAGE_NAME').includes('.preprod')) &&
      medication.brand.includes('Excedrin');

    let checked = this.props.current.hasOwnProperty(medication.nid) || isDev;

    let dosage = this.props.current[medication.nid]
      ? this.props.current[medication.nid].dosage
      : '';
    let dosageList = medication.dosages;
    let typeOfMedication =
      this.props.current[medication.nid] &&
      this.props.current[medication.nid].typeOfMedication;
    if (!typeOfMedication) {
      typeOfMedication = 'alleviating';
    }

    const { name, brand } = getMedicationNameAndBrand(row, medication);

    let dosagesComponent = dosageList.slice().reduce((acc, cur) => {
      return acc.includes(cur) ? acc : [...acc, cur];
    }, []);

    let units = medication.units || 'units';

    let iconObj = medsConstants.medicationsDosageUnits.find(
      (dos) => dos.value === units,
    );
    let icon = iconObj ? iconObj.icon_code : null;
    let _medicationDosageUnits = medsConstants.medicationsDosageUnits.find(
      (dos) => dos.value === units,
    );

    let medicationDosageUnits = _medicationDosageUnits
      ? medsStrings[_medicationDosageUnits.display_value + '_plural']
      : null;

    return (
      <ListSectionItem
        key={'med_' + medication.nid}
        style={{ marginHorizontal: designConstants.paddings.edgePadding }}
        checkbox
        onPress={() => this.onMedicationChange(medication)}
        checked={checked}
        label={name}
        secondaryLabel={
          isNothingNamed
            ? sharedStrings.list_section_content_nothing_item_subtitle
            : brand
        }
        mmpicon={icon}
        disabled={isNothingChecked}
      >
        <View>
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: 16,
            }}
          >
            <FloatingInput
              label={strings.medications_section_dosage_label}
              style={{ flex: 1 }}
              keyboardType="numeric"
              onChangeText={this.onDosageInput(medication, true)}
              value={dosage}
              customInjectedElement={
                <Text darkGray style={styles.medicationUnitsText}>
                  {toSentenceCase(medicationDosageUnits)}
                </Text>
              }
            />
          </View>
          {dosagesComponent.length > 0 && (
            <>
              <Text small style={{ marginBottom: 4 }}>
                {strings.medications_section_dosage_helper_label}
              </Text>
              <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
                {dosagesComponent.map((dose) => {
                  return (
                    <TouchableNative
                      key={'key_' + dose}
                      onPress={this.onDosageSelected(medication, dose)}
                      style={[
                        styles.doseButton,
                        { borderColor: colors.buttonBlue },
                      ]}
                    >
                      <Text blue>{dose}</Text>
                    </TouchableNative>
                  );
                })}
              </View>
            </>
          )}
        </View>
        <View>
          <Text small>{strings.medications_section_type_header}</Text>
          <View
            style={[
              styles.sectionButtonsContainer,
              { backgroundColor: colors.defaultWindowBg },
            ]}
          >
            <TouchableNative
              onPress={() => this.onTypePress(medication, 'alleviating')}
              style={[
                styles.sectionButton,
                {
                  backgroundColor:
                    typeOfMedication === 'alleviating'
                      ? getSeverityColor(0)
                      : colors.defaultWindowBg,
                },
              ]}
            >
              <Text
                medium
                white
                numberOfLines={2}
                style={[
                  typeOfMedication !== 'alleviating' && {
                    color: colors.textSecondary,
                  },
                  { textAlign: 'center' },
                ]}
              >
                {strings.medications_section_alleviating_button}
              </Text>
            </TouchableNative>
            <TouchableNative
              onPress={() => this.onTypePress(medication, 'ineffective')}
              style={[
                styles.sectionButton,
                {
                  backgroundColor:
                    typeOfMedication === 'ineffective'
                      ? getSeverityColor(5)
                      : colors.defaultWindowBg,
                },
              ]}
            >
              <Text
                medium
                white
                numberOfLines={2}
                style={[
                  typeOfMedication !== 'ineffective' && {
                    color: colors.textSecondary,
                  },
                  { textAlign: 'center' },
                ]}
              >
                {strings.medications_section_ineffective_button}
              </Text>
            </TouchableNative>
            <TouchableNative
              onPress={() => this.onTypePress(medication, 'aggravating')}
              style={[
                styles.sectionButton,
                {
                  backgroundColor:
                    typeOfMedication === 'aggravating'
                      ? getSeverityColor(10)
                      : colors.defaultWindowBg,
                },
              ]}
            >
              <Text
                medium
                white
                numberOfLines={2}
                style={[
                  typeOfMedication !== 'aggravating' && {
                    color: colors.textSecondary,
                  },
                  { textAlign: 'center' },
                ]}
              >
                {strings.medications_section_aggravating_button}
              </Text>
            </TouchableNative>
          </View>
        </View>
      </ListSectionItem>
    );
  };

  render() {
    const medicationsEmpty = !this.props.meds.some(
      (med) => !!med && med.medication,
    );
    return (
      <View>
        {this.state.meds.map(this.renderRow)}
        {medicationsEmpty && (
          <Text
            style={{
              textAlign: 'center',
              marginVertical: 12,
              marginHorizontal: 12,
            }}
          >
            {strings.medications_section_no_medications}
          </Text>
        )}
        {medicationsEmpty && (
          <View
            style={{
              flexDirection: 'row',
              margin: designConstants.paddings.edgePadding,
              justifyContent: 'center',
            }}
          >
            <Button
              tag={'medications_add_list'}
              text={strings.medications_section_add_button}
              onPress={() => {
                this.props.dispatch(clearTemporaryMedicationInfo());
                this.props.navigation.navigate('common', {
                  screen: 'searchMedication',
                });
              }}
            />
          </View>
        )}
        {!medicationsEmpty && (
          <View style={styles.footerContainer}>
            {!!this.state.hiddenFieldsCount && (
              <Text
                medium
                lightGray
                numberOfLines={2}
                style={{
                  alignSelf: 'stretch',
                  textAlign: 'center',
                  marginBottom: 12,
                }}
              >
                {strings.formatString(
                  sharedStrings.list_section_content_additional_values_can_be_shown,
                  this.state.hiddenFieldsCount,
                )}
              </Text>
            )}
            <Button
              tag={'medications_edit_list'}
              outlined
              style={{
                alignSelf: 'stretch',
              }}
              onPress={() => {
                this.props.navigation.navigate('common', {
                  screen: 'editFactorMedicationsList',
                });
              }}
              text={sharedStrings.list_section_content_add_new_edit_list_button}
            />
          </View>
        )}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    height: 48,
    paddingLeft: designConstants.paddings.edgePadding,
    paddingRight: designConstants.paddings.edgePadding,
  },
  doseButton: {
    borderRadius: 4,
    borderWidth: 1,
    height: 35,
    minWidth: 90,
    marginBottom: 8,
    marginHorizontal: 8,
    margin: 1 / PixelRatio.get(),
    alignItems: 'center',
    justifyContent: 'center',
  },
  sectionButtonsContainer: {
    flexDirection: 'row',
    height: 44,
    alignSelf: 'stretch',
    borderRadius: 4,
    marginTop: 6,
  },
  sectionButton: {
    flex: 1,
    alignSelf: 'stretch',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 4,
    borderRadius: 4,
  },
  footerContainer: {
    flexDirection: 'column',
    marginHorizontal: designConstants.paddings.edgePadding,
    marginTop: designConstants.paddings.textFieldVerticalPadding,
    marginBottom: designConstants.paddings.edgePadding,
    justifyContent: 'center',
    alignItems: 'center',
  },
  medicationUnitsText: {
    alignSelf: 'flex-end',
    position: 'absolute',
    marginTop: 16,
    right: 12,
    zIndex: -10,
  },
});

const mapStateToProps = (state, ownProps) => {
  return {
    meds: state.fields.alleviating_factor,
    current:
      state.records.current &&
      state.records.current.record &&
      state.records.current.record.medications
        ? state.records.current.record.medications
        : {},
    currentScene: state.routes.info.routeName,
    no_medications: state.records.current.record.no_medications,
  };
};

export default connect(mapStateToProps)(
  withTheme(MedicationListSectionContent),
);
